if (!customElements.get('cft-native-recommendations')) {
  customElements.define('cft-native-recommendations', class extends HTMLElement {
    async connectedCallback() {
      if (this.loaded || !this.dataset.productId || !this.dataset.url) return;
      this.loaded = true;
      const controller = new AbortController();
      this.controller = controller;
      const url = new URL(this.dataset.url, location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.set('product_id', this.dataset.productId);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('limit', String(Math.max(1, Math.min(10, Number(this.dataset.limit) || 4))));
      url.searchParams.set('intent', 'related');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(url.pathname + url.search, { signal: controller.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = doc.querySelector('[data-cft-recommendations-result]');
        if (controller.signal.aborted || !this.isConnected) return;
        if (result?.querySelector('[data-cft-card]')) {
          this.replaceChildren(...result.childNodes);
          this.hidden = false;
          this.style.display = 'block';
        }
      } catch (_) {
        // 无推荐或暂时不可读时保持隐藏，不用全部商品冒充后台推荐。
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.loaded = false;
    }
  });
}
